import React from 'react';

/**
 * PlaceOS From MerakiPeople logo
 * size="full"    — large version for auth pages
 * size="compact" — small version for sidebar
 * size="icon"    — just the "P" monogram for tight spaces
 */
export default function PlaceOSLogo({ size = 'full', className = '' }) {
  if (size === 'icon') {
    return (
      <div className={`flex items-center justify-center w-10 h-10 rounded-xl bg-[#1e2d5e] shrink-0 ${className}`}>
        <span style={{ fontFamily: "'Inter','Segoe UI',sans-serif", fontWeight: 900, fontSize: 20, color: '#f07060', lineHeight: 1 }}>P</span>
      </div>
    );
  }

  if (size === 'compact') {
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        {/* Monogram badge */}
        <div className="w-10 h-10 rounded-xl bg-[#1e2d5e] flex items-center justify-center shrink-0 shadow-md">
          <span style={{ fontFamily: "'Inter','Segoe UI',sans-serif", fontWeight: 900, fontSize: 18, color: '#f07060', lineHeight: 1 }}>P</span>
        </div>
        {/* Wordmark */}
        <div className="leading-tight">
          <div style={{ fontFamily: "'Inter','Segoe UI',sans-serif", fontWeight: 900, fontSize: 18, lineHeight: 1.1, letterSpacing: '-0.5px' }}>
            <span style={{ color: '#ffffff' }}>Place</span><span style={{ color: '#f07060' }}>OS</span>
          </div>
          <div style={{ fontFamily: "'Inter','Segoe UI',sans-serif", fontWeight: 400, fontSize: 10, color: 'rgba(255,255,255,0.55)', letterSpacing: '0.3px', marginTop: 1 }}>
            From MerakiPeople
          </div>
        </div>
      </div>
    );
  }

  // full — for login / register / forgot-password pages
  return (
    <div className={`flex flex-col items-center gap-1 ${className}`}>
      <div style={{ fontFamily: "'Inter','Segoe UI',sans-serif", fontWeight: 900, fontSize: 42, lineHeight: 1, letterSpacing: '-1px' }}>
        <span style={{ color: '#1e2d5e' }}>Place</span><span style={{ color: '#f07060' }}>OS</span>
      </div>
      <div style={{ fontFamily: "'Inter','Segoe UI',sans-serif", fontWeight: 500, fontSize: 13, color: '#1e2d5e', letterSpacing: '0.5px', opacity: 0.7 }}>
        From MerakiPeople
      </div>
    </div>
  );
}
